import React from 'react';
import { BallMark } from './icons/HandballMarks';
import { brand } from '../data/content';
export function Footer() {
  return <footer className="bg-navy-800 px-5 pb-28 pt-14 sm:pb-14" data-id="element-54" data-mp="3gg0xbxz0nnv0">
      <div className="mx-auto max-w-3xl text-center" data-id="element-55" data-mp="32oe303omwpev">
        <p className="inline-flex items-center gap-2 font-display text-lg font-black tracking-wide text-gold" data-id="element-56" data-mp="32pp39tivff18">
          <BallMark className="h-5 w-5" data-id="element-57" data-mp="36n3chl6jxmt8" />
          {brand.name}
          <span className="text-white/40" data-id="element-58" data-mp="3ugbpd4c2b8hr">·</span>
          <span className="text-white" data-id="element-59" data-mp="38qyt7e9m7ve">{brand.claim}</span>
        </p>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-white/55" data-id="element-60" data-mp="36muiocgf6ul">
          Digitale Praxis-Sammlung für Lehrkräfte und Trainerinnen und Trainer.
        </p>

        <nav aria-label="Fußzeilennavigation" className="mt-7 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm font-medium text-white/70" data-id="element-61" data-mp="3qc445h4tcaoa">
          <a href="#baende" className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-62" data-mp="2ezb9nykn184j">
            Die 6 Bände
          </a>
          <a href="#sammlung" className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-63" data-mp="3gapcti26iifg">
            Die Sammlung
          </a>
          <a href="#faq" className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-64" data-mp="3v5desm8deyqb">
            Häufige Fragen
          </a>
        </nav>

        <p className="mt-10 border-t border-white/10 pt-6 text-[11px] uppercase tracking-[0.16em] text-white/35" data-id="element-65" data-mp="817dm6kejqu2">
          © 2026 {brand.name}
        </p>
      </div>
    </footer>;
}